import React from 'react';

const BannerSection = () => {
  return (
    <section style={{ marginTop: '76px', marginBottom: '20px' }} id="specials">
      <div
        className="bg-image bg-fixed text-center"
        style={{
          backgroundImage: "url('/images/Bitejoy/bitejoy-banner.jpeg')",
          height: '500px',
        }}
      >
        <div className="mask">
          <div className="d-flex justify-content-center align-items-center h-100 mt-4">
            <div>
              <h1 className="display-1" style={{ color: '#ffffff' }}>
                The Bitejoy
              </h1>
              <hr className="my-4 bg-dark" />
              <h4 className="font-weight-light mb-4" style={{ color: '#fff' }}>
                A perfect on-the-go snack that combines taste, nutrition, and
                variety.
              </h4>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BannerSection;
